import React, { useState, useEffect } from "react";
import "../Styles/Livejob.css";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate, useLocation } from "react-router-dom";
import ApiService from "../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

const LiveJobpost = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const editJob = location.state?.editJob;

  const [showPreview, setShowPreview] = useState(false);

  const [skillInput, setSkillInput] = useState("");

  const [perkInput, setPerkInput] = useState("");

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    company_name: "",
    department: "",
    work_mode: "",
    roles_responsibilities: "",
    qualification_required: "",
    required_skills: "",
    skills: [],
    min_experience: "",
    max_experience: "",
    location: "",
    locality: "",
    openings: "",
    min_salary: "",
    max_salary: "",
    whatsapp_number: "",
    application_deadline: "",
    logo: "",
    perks_benefits: "",
    perks: [],
  });

  /* =====================================================
     EDIT MODE
  ===================================================== */

  useEffect(() => {

    if (editJob) {

      setFormData((prev) => ({

        ...prev,

        ...editJob,

        skills:
          editJob.required_skills
            ? editJob.required_skills
                .split(",")
                .map((s) => s.trim())
            : [],

        perks:
          editJob.perks_benefits
            ? editJob.perks_benefits
                .split(",")
                .map((p) => p.trim())
            : [],
      }));
    }

  }, [editJob]);

  /* =====================================================
     SKILLS
  ===================================================== */

  const skillsList = [
    "Python",
    "Java",
    "React.js",
    "Node.js",
    "SQL",
    "HTML",
    "CSS",
    "JavaScript",
    "AWS",
    "Communication",
    "Problem Solving",
  ];

  const allSkills = [
    ...new Set([
      ...skillsList,
      ...formData.skills,
    ]),
  ];

  const handleSkillKeyDown = (e) => {

    if (e.key === "Enter") {

      e.preventDefault();

      const value =
        skillInput.trim();

      if (!value) return;

      if (
        !formData.skills.includes(
          value
        )
      ) {

        const updated = [
          ...formData.skills,
          value,
        ];

        setFormData((prev) => ({

          ...prev,

          skills: updated,

          required_skills:
            updated.join(", "),
        }));
      }

      setSkillInput("");
    }
  };

  const handleSkillSelect = (
    skill
  ) => {

    const updated =
      formData.skills.includes(skill)
        ? formData.skills.filter(
            (s) => s !== skill
          )
        : [
            ...formData.skills,
            skill,
          ];

    setFormData((prev) => ({

      ...prev,

      skills: updated,

      required_skills:
        updated.join(", "),
    }));
  };

  /* =====================================================
     PERKS
  ===================================================== */

  const defaultPerks = [
    "PF/ESI",
    "Health Insurance",
    "Bonus",
    "Food",
    "Paid Leave",
    "Incentives",
    "Cab",
  ];

  const allPerks = [
    ...new Set([
      ...defaultPerks,
      ...formData.perks,
    ]),
  ];

  const handlePerkSelect = (
    perk
  ) => {

    const updated =
      formData.perks.includes(perk)
        ? formData.perks.filter(
            (p) => p !== perk
          )
        : [
            ...formData.perks,
            perk,
          ];

    setFormData((prev) => ({

      ...prev,

      perks: updated,

      perks_benefits:
        updated.join(", "),
    }));
  };

  const handlePerkKeyDown = (
    e
  ) => {

    if (e.key === "Enter") {

      e.preventDefault();

      const value =
        perkInput.trim();

      if (!value) return;

      if (
        !formData.perks.includes(
          value
        )
      ) {

        const updated = [
          ...formData.perks,
          value,
        ];

        setFormData((prev) => ({

          ...prev,

          perks: updated,

          perks_benefits:
            updated.join(", "),
        }));
      }

      setPerkInput("");
    }
  };

  /* =====================================================
     HANDLE CHANGE
  ===================================================== */

  const handleChange = (e) => {

    const {
      name,
      value,
      type,
      files,
    } = e.target;

    if (type === "file") {

      const file =
        files?.[0];

      if (!file) return;

      const reader =
        new FileReader();

      reader.onload = () => {

        setFormData((prev) => ({

          ...prev,

          logo:
            reader.result,
        }));
      };

      reader.readAsDataURL(file);

    } else {

      setFormData((prev) => ({

        ...prev,

        [name]: value,
      }));
    }
  };

  /* =====================================================
     VALIDATION
  ===================================================== */

  const validateForm = () => {

    if (!formData.title.trim()) {
      alert("Job Title is required");
      return false;
    }

    if (
      !formData.company_name.trim()
    ) {
      alert(
        "Company Name is required"
      );
      return false;
    }

    if (
      !formData.department
    ) {
      alert(
        "Department is required"
      );
      return false;
    }

    if (
      !formData.work_mode
    ) {
      alert(
        "Work Mode is required"
      );
      return false;
    }

    if (
      !formData.roles_responsibilities.trim()
    ) {
      alert(
        "Roles & Responsibilities required"
      );
      return false;
    }

    if (
      !formData.required_skills.trim()
    ) {
      alert(
        "Required Skills required"
      );
      return false;
    }

    if (
      !formData.qualification_required.trim()
    ) {
      alert(
        "Qualification required"
      );
      return false;
    }

    if (
      !formData.location.trim()
    ) {
      alert(
        "Location required"
      );
      return false;
    }

    if (
      !formData.locality.trim()
    ) {
      alert(
        "Locality required"
      );
      return false;
    }

    if (
      !formData.openings
    ) {
      alert(
        "Openings required"
      );
      return false;
    }

    if (
      !formData.application_deadline
    ) {
      alert(
        "Application deadline required"
      );
      return false;
    }

    if (
      !formData.whatsapp_number
    ) {
      alert(
        "Whatsapp number required"
      );
      return false;
    }

    return true;
  };

  /* =====================================================
     SUBMIT
  ===================================================== */

  const handleSubmit = async () => {

    try {

      if (!validateForm()) {
        return;
      }

      setLoading(true);

      /* =========================================
         PAYLOAD
      ========================================= */

      const payload = {

        title:
          formData.title.trim(),

        company_name:
          formData.company_name.trim(),

        department:
          formData.department,

        work_mode:
          formData.work_mode,

        roles_responsibilities:
          formData.roles_responsibilities.trim(),

        qualification_required:
          formData.qualification_required.trim(),

        required_skills:
          formData.required_skills.trim(),

        min_experience:
          Number(
            formData.min_experience || 0
          ),

        max_experience:
          Number(
            formData.max_experience || 0
          ),

        location:
          formData.location.trim(),

        locality:
          formData.locality.trim(),

        openings:
          Number(
            formData.openings || 0
          ),

        min_salary:
          Number(
            formData.min_salary || 0
          ),

        max_salary:
          Number(
            formData.max_salary || 0
          ),

        whatsapp_number:
          formData.whatsapp_number.trim(),

        application_deadline:
          formData.application_deadline,

        perks_benefits:
          formData.perks_benefits.trim(),

        logo:
          formData.logo || "",
      };

      console.log(
        "FINAL PAYLOAD :",
        payload
      );

      console.log(
        "HR TOKEN :",
        localStorage.getItem(
          "hrToken"
        )
      );

      let response;

      /* =========================================
         EDIT JOB (HR)
      ========================================= */

      if (editJob) {

        response =
          await JobAPI.updateHrJob(
            editJob.id,
            payload
          );

      } else {

        /* =========================================
           CREATE JOB (HR)
        ========================================= */

        response =
          await JobAPI.createHrJob(
            payload
          );
      }

      console.log(
        "API RESPONSE :",
        response.data
      );

      alert(

        editJob

          ? "Job Updated Successfully"

          : "Job Posted Successfully"
      );

      navigate("/hrdashboard");

    } catch (err) {

      console.log(
        "FULL ERROR :",
        err
      );

      console.log(
        "ERROR RESPONSE :",
        err?.response
      );

      console.log(
        "ERROR DATA :",
        err?.response?.data
      );

      const detail =
        err?.response?.data?.detail;

      if (detail) {

        let message = "";

        if (
          Array.isArray(detail)
        ) {

          message = detail
            .map((e) => {

              if (
                e?.loc &&
                e?.msg
              ) {

                return `${e.loc.join(
                  " -> "
                )} : ${e.msg}`;
              }

              return JSON.stringify(
                e
              );
            })
            .join("\n");

        } else if (
          typeof detail ===
          "string"
        ) {

          message = detail;

        } else {

          message =
            JSON.stringify(detail);
        }

        alert(message);

      } else if (
        err?.response?.data?.message
      ) {

        alert(
          err.response.data.message
        );

      } else {

        alert(
          "Job submission failed"
        );
      }

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     UI
  ===================================================== */

  return (

    <div className="hrjobpost-wrapper">

      <div className="hrjobpost-card">

        <button
          className="jobback"
          onClick={() =>
            navigate(-1)
          }
        >
          <TiArrowBack />
          Back
        </button>

        <h2 className="hrjobpost-title">
          JOB POSTING
        </h2>

        <div
          className="hrjobpost-grid"
          style={{
            alignItems:
              "flex-start",
          }}
        >

          {/* JOB TITLE */}

          <div className="hrjobpost-field">
            <label>
              Job Title*
            </label>

            <input
              name="title"
              value={
                formData.title
              }
              onChange={
                handleChange
              }
            />
          </div>

          {/* COMPANY */}

          <div className="hrjobpost-field">
            <label>
              Company Name*
            </label>

            <input
              name="company_name"
              value={
                formData.company_name
              }
              onChange={
                handleChange
              }
            />
          </div>

          {/* DEPARTMENT */}

          <div className="hrjobpost-field">
            <label>
              Department*
            </label>

            <select
              name="department"
              value={
                formData.department
              }
              onChange={
                handleChange
              }
            >
              <option value="">
                Select
              </option>

              <option value="IT">
                IT
              </option>

              <option value="Non-IT">
                Non-IT
              </option>
            </select>
          </div>

          {/* WORK MODE */}

          <div className="hrjobpost-field">
            <label>
              Work Mode*
            </label>

            <select
              name="work_mode"
              value={
                formData.work_mode
              }
              onChange={
                handleChange
              }
            >
              <option value="">
                Select
              </option>

              <option value="Remote">
                Remote
              </option>

              <option value="Hybrid">
                Hybrid
              </option>

              <option value="Onsite">
                Onsite
              </option>
            </select>
          </div>

          {/* RESPONSIBILITIES */}

          <div className="hrjobpost-field hrjobpost-full">

            <label>
              Roles & Responsibilities*
            </label>

            <textarea
              name="roles_responsibilities"
              value={
                formData.roles_responsibilities
              }
              onChange={
                handleChange
              }
            />

          </div>

          {/* EXPERIENCE */}

          <div className="hrjobpost-field">

            <label>
              Experience*
            </label>

            <div className="hrjobpost-row">

              <select
                name="min_experience"
                value={
                  formData.min_experience
                }
                onChange={
                  handleChange
                }
              >
                <option value="">
                  Min
                </option>

                <option value="0">
                  0
                </option>

                <option value="1">
                  1
                </option>

                <option value="2">
                  2
                </option>

              </select>

              <select
                name="max_experience"
                value={
                  formData.max_experience
                }
                onChange={
                  handleChange
                }
              >
                <option value="">
                  Max
                </option>

                <option value="3">
                  3
                </option>

                <option value="5">
                  5
                </option>

                <option value="10">
                  10
                </option>

              </select>

            </div>

          </div>

          {/* SKILLS */}

          <div className="hrjobpost-field hrjobpost-full">

            <label>
              Required Skills*
            </label>

            <input
              type="text"
              placeholder="Type skill and press Enter"
              value={skillInput}
              onChange={(e) =>
                setSkillInput(
                  e.target.value
                )
              }
              onKeyDown={
                handleSkillKeyDown
              }
              className="hrjobpost-skill-input mb-2"
            />

            <textarea
              rows="2"
              className="form-control bg-white"
              value={
                formData.required_skills
              }
              readOnly
            />

            <div className="mt-2 d-flex flex-wrap gap-2">

              {allSkills.map(
                (skill, i) => (

                  <span
                    key={i}
                    onClick={() =>
                      handleSkillSelect(
                        skill
                      )
                    }
                    className={`badge px-3 py-2 ${
                      formData.skills.includes(
                        skill
                      )
                        ? "bg-primary text-white"
                        : "border border-secondary text-secondary bg-transparent"
                    }`}
                    style={{
                      cursor:
                        "pointer",
                    }}
                  >
                    {skill}
                  </span>
                )
              )}

            </div>

          </div>

          {/* QUALIFICATION */}

          <div className="hrjobpost-field">

            <label>
              Qualification*
            </label>

            <input
              name="qualification_required"
              value={
                formData.qualification_required
              }
              onChange={
                handleChange
              }
            />

          </div>

          {/* SALARY */}

          <div className="hrjobpost-field">

            <label>
              Salary Range*
            </label>

            <div className="hrjobpost-row">

              <select
                name="min_salary"
                value={
                  formData.min_salary
                }
                onChange={
                  handleChange
                }
              >
                <option value="">
                  Min
                </option>

                <option value="1">
                  1
                </option>

                <option value="2">
                  2
                </option>

              </select>

              <select
                name="max_salary"
                value={
                  formData.max_salary
                }
                onChange={
                  handleChange
                }
              >
                <option value="">
                  Max
                </option>

                <option value="3">
                  3
                </option>

                <option value="5">
                  5
                </option>

              </select>

            </div>

          </div>

          {/* PERKS */}

          <div className="hrjobpost-field hrjobpost-full">

            <label>
              Perks & Benefits*
            </label>

            <input
              type="text"
              placeholder="Type perk and press Enter"
              value={perkInput}
              onChange={(e) =>
                setPerkInput(
                  e.target.value
                )
              }
              onKeyDown={
                handlePerkKeyDown
              }
              className="hrjobpost-skill-input mb-2"
            />

            <textarea
              rows="2"
              className="form-control bg-white"
              value={
                formData.perks_benefits
              }
              readOnly
            />

            <div className="mt-2 d-flex flex-wrap gap-2">

              {allPerks.map(
                (perk, i) => (

                  <span
                    key={i}
                    onClick={() =>
                      handlePerkSelect(
                        perk
                      )
                    }
                    className={`hrjobpost-chip ${
                      formData.perks.includes(
                        perk
                      )
                        ? "active"
                        : ""
                    }`}
                    style={{
                      cursor:
                        "pointer",
                    }}
                  >
                    {perk}
                  </span>
                )
              )}

            </div>

          </div>

          {/* LOCATION */}

          <div className="hrjobpost-field">

            <label>
              Job Location*
            </label>

            <input
              name="location"
              value={
                formData.location
              }
              onChange={
                handleChange
              }
            />

          </div>

          {/* LOCALITY */}

          <div className="hrjobpost-field">

            <label>
              Job Locality*
            </label>

            <input
              name="locality"
              value={
                formData.locality
              }
              onChange={
                handleChange
              }
            />

          </div>

          {/* OPENINGS */}

          <div className="hrjobpost-field">

            <label>
              Openings*
            </label>

            <input
              name="openings"
              value={
                formData.openings
              }
              onChange={
                handleChange
              }
            />

          </div>

          {/* DEADLINE */}

          <div className="hrjobpost-field">

            <label>
              Application Deadline*
            </label>

            <input
              type="date"
              name="application_deadline"
              value={
                formData.application_deadline
              }
              onChange={
                handleChange
              }
            />

          </div>

          {/* WHATSAPP */}

          <div className="hrjobpost-field">

            <label>
              Whatsapp Number*
            </label>

            <input
              type="tel"
              name="whatsapp_number"
              value={
                formData.whatsapp_number
              }
              onChange={
                handleChange
              }
              maxLength={10}
            />

          </div>

          {/* LOGO */}

          <div className="hrjobpost-field">

            <label>
              Upload Logo
            </label>

            <input
              type="file"
              onChange={
                handleChange
              }
            />

            {formData.logo && (

              <button
                type="button"
                onClick={() =>
                  setShowPreview(
                    true
                  )
                }
                style={{
                  marginTop:
                    "10px",
                }}
              >
                View Uploaded File
              </button>

            )}

          </div>

        </div>

        {/* SUBMIT */}

        <div className="hrjobpost-btn">

          <button
            onClick={
              handleSubmit
            }
            disabled={loading}
          >

            {loading
              ? "Submitting..."
              : editJob
              ? "Update Job"
              : "Post Job"}

          </button>

        </div>

      </div>

      {/* PREVIEW */}

      {showPreview &&
        formData.logo && (

          <div
            onClick={() =>
              setShowPreview(
                false
              )
            }
            style={{
              position:
                "fixed",
              inset: 0,
              background:
                "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent:
                "center",
              alignItems:
                "center",
              zIndex: 9999,
            }}
          >

            <div
              onClick={(e) =>
                e.stopPropagation()
              }
              style={{
                background:
                  "#fff",
                padding:
                  "20px",
                borderRadius:
                  "10px",
              }}
            >

              <img
                src={
                  formData.logo
                }
                alt="preview"
                style={{
                  maxWidth:
                    "500px",
                  width:
                    "100%",
                }}
              />

            </div>

          </div>
        )}

    </div>
  );
};

export default LiveJobpost;